import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { meterServiceV2 } from '../../services/meterServices';
import { CUSTOMER_RECHARGE_ACTIONS } from '../../constant/stringConstant';

export const fetchPlants = createAsyncThunk<
  any[],
  { nocIds: string[]; version?: any },
  { rejectValue: string }
>(
  CUSTOMER_RECHARGE_ACTIONS.FETCH_PLANTS,
  async ({ nocIds, version }, { rejectWithValue }) => {
    try {
      const res = await meterServiceV2.getPlants(nocIds, version);
      return res;
    } catch (error) {
      return rejectWithValue(error as any);
    }
  }
);

export interface FetchPlantsState {
  plants: any[];
  loading: boolean;
  error: string | null;
}

const initialState: FetchPlantsState = {
  plants: [],
  loading: false,
  error: null,
};

const fetchPlantsSlice = createSlice({
  name: 'fetchPlants',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlants.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPlants.fulfilled, (state, action) => {
        state.loading = false;
        state.plants = action.payload;
      })
      .addCase(fetchPlants.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || null;
      });
  },
});

export default fetchPlantsSlice.reducer;
